<script setup lang="ts">
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

defineProps<{
    isActive: boolean;
    fullPage?: boolean;
}>();

// Get the primary color from the CSS variables, so the loader has the theme color
const color = window.getComputedStyle(document.documentElement).getPropertyValue('--primary').trim();
</script>

<template>
    <Loading :active="isActive"
             :can-cancel="true"
             :is-full-page="fullPage"
             :color="color" />
</template>